module.exports = __webpack_public_path__ + "static/img/img-print-price.53208d5c.png";